import base from "@/fstore";
import validation from "@/fstore/validation";

const db = base.db;
const collection = "company";
const model = db.collection(collection);

const template = {
  name: {
    type: "string",
    required: true,
    unique: true
  },
  user: {
    type: "object",
    required: true
  },
  created: {
    type: "object",
    default: new Date()
  },
  plan: {
    type: "object",
    default: {
      name: "Starter",
      price: 0
    }
  },
  payments: {
    type: "object",
    default: []
  },
  address: {
    type: "object",
    default: {
      line1: "",
      line2: "",
      city: "",
      state: "",
      postal_code: "",
      country: ""
    }
  }
};

const create = async company => {
  // ensure the company doesn't already exist
  const exists = await getByName(company.name);

  if (exists) {
    throw new Error(`A company with name ${company.name} already exists.`);
  }

  company.user = await db.doc(`userdata/${company.user}`);
  const response = await validation.validateModel(model, company, template);
  if (!response.errors.length) await model.add(response.doc);


  return response;
};

const getById = async id => {
  let company = await model.doc(id).get();

  if (company.exists) {
    company = company.data();
    if (!company.uid) company.uid = id;
    return company;
  }

  return new Error({ code: 404, message: `Company ${id} was not found` });
};

const getByName = async name => {
  let snapshot = await model.where("name", "==", name).get();

  if (snapshot.docs.length) {
    return snapshot.docs[0].data();
  }

  return null;
};

const getByUserId = async userId => {
  const ref = await db.doc(`userdata/${userId}`);
  const company = await model.where("user", "==", ref).get();

  if (company.docs.length) {
    let doc = company.docs[0].data();
    if (!doc.uid) doc.uid = company.docs[0].id;
    return doc;
  }

  return new Error(
    `404. No company could be found attached to user '${userId}'.`
  );
};

const getRef = async companyId => {
  const ref = await db.doc(`company/${companyId}`);
  return ref;
}

const getByRef = async (companyRef, fields) => {
  const data =  (await companyRef.get()).data();  
  let company = {};

  if(fields) {
    fields.forEach(field => {
      company[field] = data[field];
    });
  }else {
    company = data;
  }

  return company;
}
const update = async (id, data, merge = true) => {
  try {
    await model.doc(id).set(data, { merge });
  } catch (error) {
    console.error(error);
  }
};

const remove = async id => {
  try {
    const response = await model.doc(id).delete();
    return response;
  } catch (error) {
    return new Error(
      `There was in issue in trying to delete the company object for '${id}'`
    );
  }
};

// validates each field from the post with the rules defined
// in the base template.
export default {
  create,
  getById,
  getRef,
  getByRef,
  getByName,
  getByUserId,
  update,
  remove
};
